/* pdp.js: interactie voor de pdp-secties (varianten, galerij, koopknop, bundel, sticky balk, tabs, aanbevelingen). */
(() => {
  if (window.__pdpLoaded) return;
  window.__pdpLoaded = true;
  const root = () => (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');

  /* Geld formatteren volgens shop.money_format (bv. €{{amount_with_comma_separator}}) */
  const formatMoney = (cents, format) => {
    const fmt = format || '€{{amount_with_comma_separator}}';
    const n = (Number(cents) || 0) / 100;
    const sep = (num, dec, ts, ds) => {
      const [i, d] = num.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (d ? ds + d : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount_no_decimals': return sep(n, 0, ',', '.');
        case 'amount_with_comma_separator': return sep(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return sep(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return sep(n, 2, "'", '.');
        default: return sep(n, 2, ',', '.');
      }
    });
  };

  /* Winkelwagen: teller in de header bijwerken + toast van de hp-header tonen */
  const afterAdd = async () => {
    try {
      const cart = await (await fetch(root() + 'cart.js')).json();
      document.querySelectorAll('[data-hp-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    } catch (e) { /* stil */ }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    const t = document.querySelector('[data-hp-toast]');
    if (t) {
      t.classList.add('is-visible');
      clearTimeout(t._h);
      t._h = setTimeout(() => t.classList.remove('is-visible'), 4000);
    } else {
      window.location.href = root() + 'cart';
    }
  };
  const addItems = async (items) => {
    const res = await fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) throw new Error('add failed');
    await afterAdd();
  };

  class PdpProduct extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-pdp-json]');
      if (!json) return;
      this.product = JSON.parse(json.textContent);
      this.money = this.dataset.money;
      this.qty = 1;
      this.variant = this.findVariantById(Number(this.querySelector('[data-variant-input]')?.value)) || this.product.variants[0];
      this.selected = this.variant ? [...this.variant.options] : [];

      this.initGallery();
      this.querySelectorAll('[data-opt]').forEach((b) => b.addEventListener('click', () => this.pickOption(b)));
      this.querySelectorAll('[data-qty]').forEach((b) => b.addEventListener('click', () => this.pickQty(b)));
      const form = this.querySelector('[data-pdp-form]');
      form && form.addEventListener('submit', (e) => this.onSubmit(e));
      this.initBundle();
      this.initReels();
      this.initSticky();
      const share = this.querySelector('[data-share]');
      share && share.addEventListener('click', () => {
        if (navigator.share) navigator.share({ title: document.title, url: location.href }).catch(() => {});
        else if (navigator.clipboard) navigator.clipboard.writeText(location.href);
      });
      this.update(false);
      /* Start op de foto van de gekozen variant */
      if (this.variant && this.variant.featured_media) {
        const i = this.slides ? this.slides.findIndex((s) => Number(s.dataset.mediaId) === this.variant.featured_media.id) : -1;
        if (i > 0) { this.track.scrollLeft = this.slides[i].offsetLeft - this.track.offsetLeft; this.mark(i); }
      }
    }

    findVariantById(id) { return this.product.variants.find((v) => v.id === id); }
    findVariant(opts) { return this.product.variants.find((v) => v.options.every((o, i) => o === opts[i])); }

    pickOption(btn) {
      const i = Number(btn.dataset.opt);
      this.selected[i] = btn.dataset.value;
      let v = this.findVariant(this.selected);
      /* Combinatie bestaat niet: neem de eerste beschikbare variant met deze waarde */
      if (!v) {
        v = this.product.variants.find((x) => x.options[i] === btn.dataset.value && x.available) ||
            this.product.variants.find((x) => x.options[i] === btn.dataset.value);
        if (v) this.selected = [...v.options];
      }
      if (!v) return;
      this.variant = v;
      this.update(true);
    }

    pickQty(btn) {
      this.qty = Number(btn.dataset.qty) || 1;
      this.querySelectorAll('[data-qty]').forEach((b) => {
        const on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      const q = this.querySelector('[data-qty-input]');
      if (q) q.value = this.qty;
    }

    update(fromUser) {
      const v = this.variant;
      if (!v) return;
      const fm = (c) => formatMoney(c, this.money);

      /* Knoppen: actief + uitverkocht per waarde (gegeven de andere gekozen opties) */
      this.querySelectorAll('[data-opt]').forEach((b) => {
        const i = Number(b.dataset.opt);
        const on = this.selected[i] === b.dataset.value;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        const test = [...this.selected];
        test[i] = b.dataset.value;
        const match = this.findVariant(test);
        b.classList.toggle('is-soldout', !match || !match.available);
      });
      this.querySelectorAll('[data-opt-label]').forEach((el) => { el.textContent = this.selected[Number(el.dataset.optLabel)] || ''; });

      /* Prijs */
      const sale = v.compare_at_price && v.compare_at_price > v.price;
      const now = this.querySelector('[data-price-now]');
      if (now) { now.textContent = fm(v.price); now.classList.toggle('is-sale', !!sale); }
      const was = this.querySelector('[data-price-was]');
      if (was) { was.hidden = !sale; if (sale) was.textContent = fm(v.compare_at_price); }
      const save = this.querySelector('[data-price-save]');
      if (save) {
        save.hidden = !sale;
        if (sale) {
          const pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
          const label = save.closest('[data-save-label]')?.dataset.saveLabel || 'Save [percent]%';
          save.textContent = label.replace('[percent]', pct);
        }
      }
      this.querySelectorAll('[data-qty]').forEach((b) => {
        const chip = b.querySelector('[data-qty-total]');
        if (chip) chip.textContent = fm(v.price * Number(b.dataset.qty));
      });

      /* Formulier + knop */
      const input = this.querySelector('[data-variant-input]');
      if (input) input.value = v.id;
      const atc = this.querySelector('[data-atc]');
      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? atc.dataset.labelAdd : atc.dataset.labelSoldout;
      }

      /* Sticky balk */
      const sp = this.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = fm(v.price);
      const sv = this.querySelector('[data-sticky-variant]');
      if (sv) sv.textContent = v.title;
      const sb = this.querySelector('[data-sticky-add]');
      if (sb) sb.disabled = !v.available;

      /* Bundel: hoofdproduct volgt de gekozen variant */
      const main = this.querySelector('[data-bundle-item][data-main]');
      if (main) {
        main.dataset.variantId = v.id;
        main.dataset.price = v.price;
        main.dataset.compare = sale ? v.compare_at_price : v.price;
        const bv = main.querySelector('[data-bundle-variant]');
        if (bv) bv.textContent = v.title;
        const bn = main.querySelector('[data-bundle-now]');
        if (bn) bn.textContent = fm(v.price);
        const bw = main.querySelector('[data-bundle-was]');
        if (bw) { bw.hidden = !sale; if (sale) bw.textContent = fm(v.compare_at_price); }
        this.updateBundle();
      }

      if (fromUser) {
        if (v.featured_media) this.goToMedia(v.featured_media.id);
        try { history.replaceState(null, '', this.dataset.url + '?variant=' + v.id); } catch (e) { /* stil */ }
      }
    }

    async onSubmit(e) {
      e.preventDefault();
      const atc = this.querySelector('[data-atc]');
      const err = this.querySelector('[data-error]');
      if (!this.variant || !this.variant.available) return;
      atc && atc.classList.add('is-loading');
      err && (err.hidden = true);
      try {
        await addItems([{ id: this.variant.id, quantity: this.qty }]);
      } catch (x) {
        err && (err.hidden = false);
      } finally {
        atc && atc.classList.remove('is-loading');
      }
    }

    /* Galerij: scroll-snap track + thumbnails */
    initGallery() {
      this.track = this.querySelector('[data-gallery-track]');
      if (!this.track) return;
      this.slides = [...this.track.children];
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.thumbTrack = this.querySelector('[data-thumbs]');
      this.prevBtn = this.querySelector('[data-gallery-prev]');
      this.nextBtn = this.querySelector('[data-gallery-next]');
      this.index = 0;
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(Number(t.dataset.thumb))));
      this.prevBtn && this.prevBtn.addEventListener('click', () => this.goTo(this.index - 1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.goTo(this.index + 1));
      this.track.addEventListener('scroll', () => {
        clearTimeout(this._gs);
        this._gs = setTimeout(() => {
          const i = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
          if (i !== this.index) this.mark(i);
        }, 60);
      }, { passive: true });
      this.mark(0);
    }
    goTo(i) {
      if (!this.slides || !this.slides.length) return;
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      this.track.scrollTo({ left: this.slides[i].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      this.mark(i);
    }
    goToMedia(id) {
      if (!this.slides) return;
      const i = this.slides.findIndex((s) => Number(s.dataset.mediaId) === id);
      if (i >= 0) this.goTo(i);
    }
    mark(i) {
      this.index = i;
      this.slides.forEach((s, j) => { if (j !== i) s.querySelectorAll('video').forEach((v) => v.pause()); });
      this.thumbs.forEach((t, j) => t.classList.toggle('is-active', j === i));
      const t = this.thumbs[i];
      if (t && this.thumbTrack) {
        const x = t.offsetLeft - this.thumbTrack.offsetLeft;
        if (x < this.thumbTrack.scrollLeft || x + t.offsetWidth > this.thumbTrack.scrollLeft + this.thumbTrack.clientWidth) {
          this.thumbTrack.scrollTo({ left: x - 8, behavior: 'smooth' });
        }
      }
      if (this.prevBtn) this.prevBtn.disabled = i === 0;
      if (this.nextBtn) this.nextBtn.disabled = i === this.slides.length - 1;
    }

    /* Vaak samen gekocht */
    initBundle() {
      this.bundle = this.querySelector('[data-bundle]');
      if (!this.bundle) return;
      this.bundle.querySelectorAll('[data-bundle-item] input').forEach((c) => c.addEventListener('change', () => this.updateBundle()));
      const btn = this.bundle.querySelector('[data-bundle-add]');
      btn && btn.addEventListener('click', async () => {
        const items = [...this.bundle.querySelectorAll('[data-bundle-item]')]
          .filter((it) => it.querySelector('input').checked)
          .map((it) => ({ id: Number(it.dataset.variantId), quantity: 1 }));
        if (!items.length) return;
        btn.disabled = true;
        try { await addItems(items); } catch (e) { /* stil */ } finally { btn.disabled = false; }
      });
      this.updateBundle();
    }
    updateBundle() {
      if (!this.bundle) return;
      let total = 0, compare = 0, count = 0;
      this.bundle.querySelectorAll('[data-bundle-item]').forEach((it) => {
        if (!it.querySelector('input').checked) return;
        total += Number(it.dataset.price);
        compare += Number(it.dataset.compare);
        count += 1;
      });
      const t = this.bundle.querySelector('[data-bundle-total]');
      const c = this.bundle.querySelector('[data-bundle-compare]');
      if (t) t.textContent = formatMoney(total, this.money);
      if (c) { c.hidden = compare <= total; c.textContent = formatMoney(compare, this.money); }
      const btn = this.bundle.querySelector('[data-bundle-add]');
      if (btn) btn.disabled = count === 0;
    }

    /* Video's: afspelen in beeld, tik = geluid */
    initReels() {
      this.querySelectorAll('[data-reel]').forEach((reel) => {
        const v = reel.querySelector('video');
        if (!v) return;
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) => entries.forEach((en) => {
            if (en.isIntersecting) { v.preload = 'auto'; v.play().catch(() => {}); } else v.pause();
          }), { threshold: 0.4 }).observe(reel);
        }
        reel.addEventListener('click', () => {
          v.muted = !v.muted;
          reel.classList.toggle('is-sound', !v.muted);
          if (v.paused) v.play().catch(() => {});
        });
      });
    }

    /* Sticky balk: zichtbaar als de koopknop boven uit beeld is */
    initSticky() {
      const bar = this.querySelector('[data-sticky]');
      const atc = this.querySelector('[data-atc]');
      if (!bar || !atc || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.querySelector('[data-sticky-add]').tabIndex = show ? 0 : -1;
      }).observe(atc);
      bar.querySelector('[data-sticky-add]').addEventListener('click', async (e) => {
        const b = e.currentTarget;
        if (!this.variant || !this.variant.available) return;
        b.disabled = true;
        try { await addItems([{ id: this.variant.id, quantity: this.qty }]); } catch (x) { /* stil */ } finally { b.disabled = false; }
      });
    }
  }
  if (!customElements.get('pdp-product')) customElements.define('pdp-product', PdpProduct);

  /* Tabs */
  class PdpTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.tabs.forEach((t) => t.addEventListener('click', () => this.select(t.dataset.tab)));
    }
    select(id) {
      this.tabs.forEach((t) => {
        const on = t.dataset.tab === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach((p) => { p.hidden = p.dataset.panel !== id; });
    }
  }
  if (!customElements.get('pdp-tabs')) customElements.define('pdp-tabs', PdpTabs);

  /* Aanbevelingen via de Section Rendering API */
  class PdpRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.children.length || !this.dataset.url) return;
      const load = async () => {
        try {
          const html = await (await fetch(this.dataset.url)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('pdp-recommendations');
          if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
        } catch (e) { /* stil */ }
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(([en]) => { if (en.isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 600px 0px' });
        io.observe(this);
      } else load();
    }
  }
  if (!customElements.get('pdp-recommendations')) customElements.define('pdp-recommendations', PdpRecommendations);
})();
